const user = {
    loginUrl: "https://login.nstl.gov.cn/login",
    defaultCallBackUrl: "https://cart.nstl.gov.cn",
    isLogin: false
}

user.login = function(callBackUrl) { //跳转登录
    if (callBackUrl != undefined) {
        window.location.href = user.loginUrl + "?service=" + callBackUrl;
    } else {
        window.location.href = user.loginUrl + "?service=" + user.defaultCallBackUrl;
    }
}

user.loginUser = function(obj) { //获取登录用户信息
    obj.$http.get("/sso/getUser.shtml").then(response => {
        if (response.data.code == 0) {
            return response.data.data;
        } else {
            console.log("用户未登录");
            obj.$user.login(location.href);
        }
    });
}

export default user;


// WEBPACK FOOTER //
// ./src/utils/UserUtil.js